import { render, staticRenderFns } from "./ListProductsByPriceConfigs.vue?vue&type=template&id=980afade&scoped=true"
import script from "./ListProductsByPriceConfigs.vue?vue&type=script&lang=js"
export * from "./ListProductsByPriceConfigs.vue?vue&type=script&lang=js"
import style0 from "./ListProductsByPriceConfigs.vue?vue&type=style&index=0&id=980afade&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "980afade",
  null
  
)

export default component.exports